<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "~/shared/lib/utils";
import { cardVariants, type CardVariants } from ".";

interface Props {
  variant?: CardVariants["variant"];
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();
</script>

<template>
  <div
    :class="cn(cardVariants({ variant }), props.class)"
  >
    <slot />
  </div>
</template>
